module.exports = __webpack_public_path__ + "img/icon-input-clear.3831af1e.png";